<template>
	<Component
		:is="as"
		class="flex max-w-full items-center justify-center space-x-1.5 text-sm font-semibold whitespace-nowrap select-none *:truncate"
		:class="{
			'rounded-full': borderRounded,
			'rounded-lg': !borderRounded,
			'h-9 min-h-9': size === 'sm',
			'h-10 min-h-10': size === 'md',
			'h-11 min-h-11 uppercase': size === 'lg',
			'px-3': !square,
			'w-9': square && size === 'sm',
			'w-10': square && size === 'md',
			'w-11': square && size === 'lg',
			'text-label-primary': ['primary', 'purple', 'green', 'cyan'].includes(
				color
			),
			'text-label-secondary shadow-button': color === 'secondary',
			'bg-red uppercase': color === 'primary',
			'bg-fill-secondary': color === 'secondary',
			'bg-purple uppercase': color === 'purple',
			'bg-green uppercase': color === 'green',
			'bg-cyan uppercase': color === 'cyan',
			'*:opacity-30': disabledComputed
		}"
		@click="click"
		:disabled="disabledComputed"
		v-hover="{ impact: size === 'lg' ? 'medium' : 'soft' }"
	>
		<LoaderIcon class="h-5 w-5" v-if="loading" />
		<slot v-else />
	</Component>
</template>
<script setup lang="ts">
import LoaderIcon from '@/assets/icons/loader.svg'
import { computed } from 'vue'

const props = withDefaults(
	defineProps<{
		as?: 'button' | 'a'
		borderRounded?: boolean
		size: 'sm' | 'md' | 'lg'
		color: 'primary' | 'secondary' | 'purple' | 'green' | 'cyan'
		square?: boolean
		disabled?: boolean
		loading?: boolean
	}>(),
	{
		as: 'button'
	}
)

const emit = defineEmits<{
	(e: 'click'): void
}>()

const click = () => {
	if (props.disabled) {
		return
	}

	emit('click')
}

const disabledComputed = computed(() => props.loading || props.disabled)
</script>
